import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=210f5c78&scoped=true&"
import script from "./CloseButton.vue?vue&type=script&lang=ts&"
export * from "./CloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=210f5c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f5c78",
  null
  
)

export default component.exports